import React from 'react'

const Bottle = ({classes}) => (
    <div className={`bottle-img ${classes}`} />
)

export default Bottle
